// npm

// css
import '../../scss/pages/page-interview01.scss';

// libs
import RecruitJobInterview from '../_libs/RecruitJobInterview';

// utils
import RecruitFoundation from '../_utils/RecruitFoundation';
RecruitFoundation();

document.addEventListener('DOMContentLoaded', () => {
	RecruitJobInterview();
});

window.addEventListener('load', () => {});
